import { Api } from './Api'

class OrganizationSetting {
  get (customerId, siteId) {
    return fetch(Api.getBaseUrl() + 'organizationsetting/' + customerId + '?site_id=' + siteId, Api.getOptions())
  }
}

export default OrganizationSetting
